import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import LinearProgress from 'apollo-react/components/LinearProgress';
import classNames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchProductChildrenByItemId } from '../../../actions/ProductHierarchyActions';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import {
  getIsChildrenPending,
  getIsParentLoading,
} from '../../../selectors/ProductHierarchySelectors';
import { getUITA } from '../../../utils/commonUtils';
import { NODE_MARGIN } from '../constants';

const useStyles = makeStyles({
  root: {
    marginLeft: 32,
    marginTop: 5,
    position: 'relative',

    '&::before': {
      content: '""',
      position: 'absolute',
      left: -NODE_MARGIN,
      top: -8,
      borderLeft: '2px solid #ccc',
      borderBottom: '2px solid #ccc',
      width: 17,
      height: 24,
    },
  },
  rootLoading: {
    '&::before': {
      top: -23,
    },
  },
  loading: {
    width: 250,
    margin: NODE_MARGIN,
    height: 4,
  },
});

const ShowMoreButton = ({ itemId, entityName }) => {
  const isLoading = useSelector((state) => getIsParentLoading(state, { itemId }));
  const isChildrenPending = useSelector(getIsChildrenPending);

  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();

  const handleShowMore = () => {
    dispatch(fetchProductChildrenByItemId({ itemId, entityName }));
  };

  return (
    <div className={classNames(classes.root, isLoading && classes.rootLoading)}>
      {isLoading ? (
        <LinearProgress className={classes.loading} />
      ) : (
        <Button
          ui-ta={getUITA('ShowMoreButton', itemId)}
          disabled={isChildrenPending}
          variant="text"
          size="small"
          onClick={handleShowMore}
        >
          {translateString('Show more')}
        </Button>
      )}
    </div>
  );
};

export default ShowMoreButton;
